module.exports = __webpack_public_path__ + "assets/media/agentDefaultAvatar.36c11761.svg";